export const DOWNLOAD_FILE_REQUEST = 'app/Global/DOWNLOAD_FILE_REQUEST';

export const DOWNLOAD_FILE_SUCCESS = 'app/Global/DOWNLOAD_FILE_SUCCESS';

export const DOWNLOAD_FILE_ERROR = 'app/Global/DOWNLOAD_FILE_ERROR';

export const SAVE_NAVBAR_HEIGHT = 'app/Global/SAVE_NAVBAR_HEIGHT';
